import * as React from 'react';

import appUrls from 'base/app/urls';
import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  StatusFilter,
  SearchInput,
} from 'templates/content';
import { DetailsSwitch } from 'templates/details';
import MeditationsDetails from './PodcastDetails';
import { usePodcastList } from '../queries';
import { createTagString } from 'common/utils/tags';

const fields = {
  search: 'search',
  filter: 'filter',
  sort: 'sort',
};

const PodcastsList = () => {
  const { data, isError } = usePodcastList();
  const context = {
    data: data?.values.map((podcast) => ({
      ...podcast,
      titleSuffix: createTagString(podcast),
    })),
    path: {
      details: appUrls.PODCASTS.DETAILS,
      list: appUrls.PODCASTS.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title="Podcasts">
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError} />
        <DetailsSwitch>
          <MeditationsDetails />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

export default PodcastsList;
